import {NetworkEnums} from '../../../../shared/GameEnums.ts'
import {type MatchmakingStatusUpdate} from '../../../../shared/matchmaking/MatchmakingInterfaces.ts'
import {type SocketActionController} from './SocketActionController.ts'
import {type BaseError} from '../../../../shared/errors/BaseError.ts'
import MatchmakingState = NetworkEnums.MatchmakingState
import {SocketMatchmakingSend} from './SocketMatchmakingSend.ts'
import type {SocketController} from './SocketController.ts'

type MatchmakingStateUpdateData = NetworkEnums.MatchmakingStateUpdateData

export class SocketMatchmakingListen {
    readonly socketActionController: SocketActionController
    // eslint-disable-next-line func-call-spacing
    private readonly matchmakingStateHandlers = new Map<MatchmakingState, (data: any) => void>()

    constructor(socketController: SocketController, socketActionController: SocketActionController) {
        this.socketActionController = socketActionController

        socketController.setStateHandler(NetworkEnums.State.MatchmakingStateUpdate, (data: MatchmakingStateUpdateData) => {
            this.matchmakingStateHandlers.get(data.type)?.(data.payload)
        })

        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingUpdate, (matchmakingStatusUpdate: MatchmakingStatusUpdate) => {
            this.socketActionController.onMatchmakingUpdate(matchmakingStatusUpdate)
        })

        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingError, (error: BaseError) => {
            this.socketActionController.onMatchmakingError(error)
        })

        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingDisableAdblock, (data: any) => {
            this.socketActionController.onMatchmakingDisableAdblock()
        })

        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingReconnect, (data: any) => {
            SocketMatchmakingSend.sendFindGame()
        })
    }
}
